(() => {
  'use strict';
  const selector = '[data-tp-pdp-r2]';

  function faqRows(body) {
    for (const heading of Array.from(body.children)) {
      if (heading.tagName !== 'H3' || heading.querySelector('a,button,input,select,summary,details')) continue;
      const following = [];
      let next = heading.nextSibling;
      while (next && !(next.nodeType === 1 && /^(H2|H3|DETAILS)$/.test(next.tagName))) {
        following.push(next);
        next = next.nextSibling;
      }
      if (!following.some(node => node.textContent.trim())) continue;
      const disclosure = document.createElement('details');
      disclosure.className = 'tp-r2-faq-item';
      const summary = document.createElement('summary');
      heading.before(disclosure);
      summary.append(heading);
      disclosure.append(summary, ...following);
    }
  }

  function arrangeDetails(root) {
    const details = root.querySelector('.tp-a-product-details');
    if (!details) return;
    const parents = new Set(Array.from(details.querySelectorAll('h2')).map(h => h.parentElement));
    for (const parent of parents) {
      if (parent.dataset.tpR2Grouped === 'true') continue;
      parent.dataset.tpR2Grouped = 'true';
      for (const heading of Array.from(parent.children)) {
        if (heading.tagName !== 'H2') continue;
        const nodes = [];
        let next = heading.nextSibling;
        while (next && !(next.nodeType === 1 && next.tagName === 'H2')) {
          nodes.push(next);
          next = next.nextSibling;
        }
        const row = document.createElement('section');
        row.className = 'tp-r2-detail-row';
        const body = document.createElement('div');
        body.className = 'tp-r2-detail-body';
        heading.before(row);
        row.append(heading, body);
        body.append(...nodes);
        if (/domande frequenti|faq/i.test(heading.textContent)) {
          row.classList.add('tp-r2-faq-row');
          faqRows(body);
        }
      }
    }
  }

  function enhance(root) {
    if (root.dataset.tpPdpR2Ready === 'true') return;
    const product = root.querySelector('.product');
    const info = root.querySelector('[id^="ProductInfo-"]');
    const title = info && Array.from(info.children).find(n => n.classList.contains('product__title'));
    const lead = info && Array.from(info.children).find(n => n.classList.contains('lead'));
    if (!product || !info || !title) return;
    const heading = document.createElement('div');
    heading.className = 'tp-r2-pdp-heading';
    product.prepend(heading);
    heading.append(title);
    if (lead) heading.append(lead);
    arrangeDetails(root);
    root.dataset.tpPdpR2Ready = 'true';
  }

  function init(scope) {
    if (scope.matches && scope.matches(selector)) enhance(scope);
    scope.querySelectorAll(selector).forEach(enhance);
  }

  if (window.tpPdpR2Presentation) {
    window.tpPdpR2Presentation.init(document);
    return;
  }
  window.tpPdpR2Presentation = { init };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
